export const actionButtonStyles = { width: 170 };
export const noETLJobsToDisplayStyles = { opacity: 0.3, fontWeight: 600 };
export const scheduleBlockStyles = {
  p: 2,
  my: 2,
  backgroundColor: '#F5F5F5',
  borderRadius: 1,
};

export const jobStatusCellStyles = (hasDetails: boolean, customColor?: string) =>
  ({
    cursor: hasDetails ? 'pointer' : 'default',
    backgroundColor: customColor || 'transparent',
    p: 1,
    fontSize: '1.5rem',
    '&:hover': {
      backgroundColor: hasDetails ? '#0000001f' : customColor,
    },
  }) as const;
